import PropTypes from 'prop-types';

const IconGeofencingValid = (props) => {
  const { color } = props;

  return (
    <svg id="geofencing_valid" xmlns="http://www.w3.org/2000/svg" height={24} width={24} {...props}>
      <path
        id="geofencing_valid_earth"
        fill={color || '#000000'}
        d="M11.9,22c-1.4,0-2.7-0.3-3.9-0.8c-1.2-0.5-2.3-1.2-3.2-2.1
        s-1.6-2-2.1-3.2c-0.5-1.2-0.8-2.5-0.8-3.9s0.3-2.7,0.8-3.9C3.3,6.9,4,5.8,4.9,4.9s2-1.6,3.2-2.1C9.3,2.2,10.6,2,11.9,2
        c2.4,0,4.6,0.8,6.4,2.3c1.8,1.5,3,3.4,3.4,5.7h-2c-0.3-1.2-0.9-2.3-1.7-3.3c-0.8-1-1.8-1.7-3-2.2V5c0,0.5-0.2,1-0.6,1.4
        C14,6.8,13.5,7,12.9,7h-2v2c0,0.3-0.1,0.5-0.3,0.7C10.5,9.9,10.2,10,9.9,10h-2v2h2v3h-1l-4.8-4.8c0,0.3-0.1,0.6-0.1,0.9
        c0,0.3-0.1,0.6-0.1,0.9c0,2.2,0.8,4.1,2.3,5.6S9.7,20,11.9,20V22z"
      />
      <polygon
        id="geofencing_valid_tick"
        fill={color || '#000000'}
        points="15.6,20.2 11.6,16.2 12.8,15 15.6,17.7 20.9,12.3 22.2,13.5 "
      />
    </svg>
  );
};

IconGeofencingValid.propTypes = {
  color: PropTypes.string
};

export default IconGeofencingValid;
